import Quill from 'quill';

// Register fonts
const Font = Quill.import('formats/font');
Font.whitelist = [
  'sans-serif',
  'serif',
  'monospace',
  'roboto',
  'lato',
  'poppins',
  'montserrat'
];
Quill.register(Font, true);
